import { render, staticRenderFns } from "./PreHeader.vue?vue&type=template&id=fff2391e&"
import script from "./PreHeader.vue?vue&type=script&lang=js&"
export * from "./PreHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports